// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"63bf63e0","498":"6addbe94","703":"041860bd"}[chunkId] + ".chunk.js";
};